module.exports = __webpack_public_path__ + "img/ProhorIcon.e7cbfe9b.svg";